import type { CatalogComponents } from '@lifeserver/xsolla';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

type XsollaVirtualItem =
    CatalogComponents['schemas']['Virtual-Items-Currency_admin-virtual-item'];

export const XSOLLA_VIRTUAL_ITEMS_QUERY_KEY = 'xsollaVirtualItems';

async function fetchVirtualItem(sku: string) {
    const { data } = await axios.get<XsollaVirtualItem>(
        `/api/xsolla/v2/virtual-items/${sku}`,
    );
    return data;
}

export const useXsollaVirtualItem = (sku: string = '') => {
    return useQuery({
        queryKey: [XSOLLA_VIRTUAL_ITEMS_QUERY_KEY, sku],
        queryFn: () => fetchVirtualItem(sku),
        enabled: Boolean(sku),
    });
};
